import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 19"
}, n = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M1 9.5c0-3.771 0-5.657 1.172-6.828S5.229 1.5 9 1.5h4c3.771 0 5.657 0 6.828 1.172S21 5.729 21 9.5s0 5.657-1.172 6.828S16.771 17.5 13 17.5H9c-3.771 0-5.657 0-6.828-1.172S1 13.271 1 9.5Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "m5 5.5 2.159 1.8C8.996 8.83 9.914 9.595 11 9.595s2.005-.765 3.841-2.296L17 5.5"
}, null, -1), c = [
  n,
  s
];
function l(d, h) {
  return t(), o("svg", r, [...c]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
